import React from 'react'
import {  
  Paper,
  Typography,  
  Tooltip,
} from '@material-ui/core'
import { InfoOutlined } from '@material-ui/icons'

const Stats = (props) => {
  const {data, metric, darkMode} = props
  const getStats = () => {
    const totalCustomerCount = data.map(({Data}) => Data.map(({Customers}) => Customers).reduce((a,b) => a + b, 0)).reduce((a,b) => a + b, 0)
    const uniqueDel = data.map(({Data}) => Data.map(({UniqueDel}) => UniqueDel).reduce((a,b) => a + b, 0)).reduce((a,b) => a + b, 0)
    const uniqueAppends = data.map(({Data}) => Data.map(({Appends}) => Appends).reduce((a,b) => a + b, 0)).reduce((a,b) => a + b, 0)

    let dataArr = [
      {title: "Unique Deliverable Addresses", value: uniqueDel, color: "#ffa938", info: "Number of CASS-verified addresses within the trade area"},
      {title: "Unique Appends", value: uniqueAppends, color: "#cf9af5", info: "Number of addresses with available demographic data"},
      {title: "Good Address Rate", value: `${(uniqueDel / totalCustomerCount * 100).toFixed(1)}%`, color: "#e0ce1b", info: "Percent of all addresses that are deliverable"},
      {title: "Unique Match Rate", value: `${(uniqueAppends / totalCustomerCount * 100).toFixed(1)}%`, color: "#6ac900", info: "Percent of all addresses that have available demographic data"},
    ]
    
    return dataArr
  }

  const getMetrics = () => {
    let metricData = metric.filter(({MetricType}) => MetricType !== "Credit Score")
    let dataArr = []
    let colors = ["#25aae1", "#ff7dfd", "#48bda3", "#e39f56"]    
    
    metricData.forEach((element) => {
      element.Data.reverse().splice(4)
    })

    console.log(metricData)
    
    for(let i = 0; i < metricData[0].Data.length; i++) {
      let dataObj = {}
      dataObj["year"] = metricData[0].Data[i].Year
      dataObj["color"] = colors[i]
      for(let j = 0; j < metricData.length; j++) {
        dataObj[`${metricData[j].MetricType.split(" ")[0]}`] = metricData[j].Data[i].Cust_Average
      }
      dataArr.push(dataObj)
    }

    return dataArr
  }

    return(
      <div>
        <div className="stats">
          {getStats().map(({title, value, info, color}, i) => (
            <Paper 
              className={`stat-card ${darkMode ? "bg-dk" : "bg-lt"}`} 
              style={{border: `1px solid ${color}`}}
              key={`${title}-${i}`}
            >              
              <Tooltip 
                className="tooltip"                
                title={<Typography style={{fontSize: "13px"}}>{info}</Typography>}
                placement="bottom-end"
              >
                <InfoOutlined className="help" style={{fontSize: "15px"}}/>
              </Tooltip>
              <Typography display="block" variant="caption" className="header" style={{color: color}}>{title}</Typography>
              <Typography display="block" variant="caption" className={`stat-value ${darkMode ? "dk" : "lt"}`}>{value.toLocaleString("en")}</Typography>
            </Paper>
          ))}                  
        </div>        
        <div className="stats" style={{marginTop: "15px", marginBottom: "15px"}}>
          {getMetrics().map(({year, color, Age, HH}, i) => (
            <Paper
              key={`${year}-${i}`}
              className={`stat-card ${darkMode ? "bg-dk" : "bg-lt"}`}
              style={{border: `1px solid ${color}`}}
            >
              <Tooltip
                title={<Typography style={{fontSize: "13px"}}>Average age and household income of customers during {year}</Typography>}
                className="tooltip"
                placement="bottom-end"
              >
               <InfoOutlined className="help" style={{fontSize: "15px"}}/>
              </Tooltip>
              <Typography display="block" variant="caption" className="header" style={{color: color}}>{year}</Typography>
              <div className="yearly-stats">
                <Typography display="block" variant="caption" className={`subheader ${darkMode ? "dk" : "lt"}`}>
                  AVERAGE AGE<br/>
                  <span className="yearly-value">{Age && Age !== "" ? Age : "N/A"}</span>
                </Typography>                
                <div style={{borderLeft: `0.1px solid ${darkMode ? "#fff" : "#6e6e6e"}`}}/>
                <Typography display="block" variant="caption" className={`subheader ${darkMode ? "dk" : "lt"}`}>
                  AVERAGE HHI<br/>
                  <span className="yearly-value">{HH && HH !== "" ? `$${Math.round(HH).toLocaleString("en")}` : "N/A"}</span>
                </Typography>
              </div>
            </Paper>
          ))}                              
        </div>                         
      </div>
    )
  }

export default Stats
